import React from "react";
import { ScheduleExtensionContainer } from "../../../containers";

const ScheduleExtension = (props) => {
  return <ScheduleExtensionContainer {...props} />;
};

export default ScheduleExtension;
